<template>
  <span v-if="label" class="vanguard-label">
    <!-- Deux modes de rendu :
         - plainText=true  : on strip toutes les balises HTML et on rend
           via {{ }}. Utilise sur les cartes d'offres ou la mise en valeur
           typographique (gras / italique) est portee par le CSS de la
           carte, pas par le contenu Salesforce, pour eviter les rendus
           "<strong>...</strong>" doubles et garder une typo coherente.
         - plainText=false : v-html avec le HTML decode (comportement
           historique, utilise dans le cart standalone, le panier, etc.). -->
    <template v-if="plainText">{{ plainLabel }}</template>
    <span v-else v-html="renderHTML(label)"></span>
  </span>
</template>

<script>
import { stripDecodedHtml } from "@/services/text";

export default {
  name: "ChoiceVanguardLabel",
  props: {
    choice: {
      type: Object,
    },
    plainText: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    label() {
      // This is computed because choice may change after init
      return this?.choice?.vanguardLabel;
    },
    plainLabel() {
      return stripDecodedHtml(this.label);
    },
  },
};
</script>
